import { render, staticRenderFns } from "./recheck.vue?vue&type=template&id=0ba56c6e&scoped=true&"
import script from "./recheck.vue?vue&type=script&lang=js&"
export * from "./recheck.vue?vue&type=script&lang=js&"
import style0 from "./recheck.vue?vue&type=style&index=0&id=0ba56c6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba56c6e",
  null
  
)

export default component.exports